export const SET_ANNOUNCEMENTS = 'SET_ANNOUNCEMENTS';
export const ADD_ANNOUNCEMENT = 'ADD_ANNOUNCEMENT';
export const UPDATE_ANNOUNCEMENT = 'UPDATE_ANNOUNCEMENT';
export const REMOVE_ANNOUNCEMENT = 'REMOVE_ANNOUNCEMENT';
export const SET_META = 'SET_META';
export const SET_UI_FLAG = 'SET_UI_FLAG';
